import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import ProfileCard from '../../UI/ProfileCard/ProfileCard';
import { Layout } from './Profile.styles';

function ProfileView() {
  document.title = 'Profile';

  const userData = { ...store.user.data };
  return (
    <Layout>
      <ProfileCard userData={userData} />
    </Layout>
  );
}

export default observer(ProfileView);
